import React from 'react'
// import { X } from 'lucide-react'
import {
  LegendPanelContainer,
  LegendHeader,
  LegendTitle,
  LegendClose,
  LegendContent,
  LegendGradient,
  LegendLabels,
  LegendUnit,
  LegendCategories,
  LegendCategoryItem,
  LegendColorBox,
  LegendLabel,
} from './LegendPanel.styles'
import { LegendPanelProps } from './LegendPanel.types'

export const LegendPanel: React.FC<LegendPanelProps> = ({
  active,
  legend,
  onItemClick,
  className,
  position,
  width,
  zIndex,
  showCloseButton = false,
  onClose,
}) => {
  if (!legend) return null

  return (
    <LegendPanelContainer
      $active={active}
      $position={position}
      $width={width}
      $zIndex={zIndex}
      className={`legend-panel ${className || ''}`}
    >
      <LegendHeader>
        <LegendTitle>{legend.title}</LegendTitle>
        {showCloseButton && onClose && (
          <LegendClose onClick={onClose} aria-label="Close legend">
            X
          </LegendClose>
        )}
      </LegendHeader>
      <LegendContent>
        {legend.type === 'gradient' ? (
          <>
            <LegendGradient $colors={legend.colors} />
            <LegendLabels>
              {legend.labels ? (
                legend.labels.map((label, index) => (
                  <span key={index}>{label}</span>
                ))
              ) : (
                <>
                  <span>{legend.min}</span>
                  <span>{legend.max}</span>
                </>
              )}
            </LegendLabels>
            {legend.unit && <LegendUnit>{legend.unit}</LegendUnit>}
          </>
        ) : (
          <LegendCategories>
            {legend.items.map((item) => (
              <LegendCategoryItem
                key={item.id}
                $clickable={!!onItemClick}
                onClick={() => onItemClick?.(item.id)}
              >
                {item.icon || <LegendColorBox $color={item.color} />}
                <LegendLabel $active={item.active}>{item.label}</LegendLabel>
              </LegendCategoryItem>
            ))}
          </LegendCategories>
        )}
      </LegendContent>
    </LegendPanelContainer>
  )
}
